import React from 'react';
import {useNavigate} from 'react-router-dom';

import {cleanEventsInfo} from 'src/modules/events/services/actions';
import {createMainTabbRoutePath} from 'src/modules/tabs-panel/tabs-route-planner';
import {TabId} from 'src/modules/tabs-panel/typedefs';
import {getUniqueAttributeTitleCount} from 'src/openapi/apis/AttributeControllerApi';
import {getChangeRequestCount} from 'src/openapi/apis/ChangeRequestControllerApi';
import {
    getAllEvents,
    getEventCount,
    removeEventById,
    removeEventByIdFailure,
    removeEventByIdSuccess,
} from 'src/openapi/apis/EventControllerApi';
import {useAppDispatch} from 'src/store';

import {FlatButton} from '@pb/kit-component-button';
import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';
import {Icons} from '@pb/kit-component-icon';
import {OnCloseNote, Status, usePushNotification} from '@pb/kit-component-push-notification';

type Props = {
    id: number,
    code: string,
    source: string,
    onClose: OnCloseNote,
};

export const PushNotificationRemoveEvent = ({id, code, source, onClose}: Props) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {onCreateNote} = usePushNotification();

    const onClick = () => {
        dispatch(removeEventById({id})).then(e => {
            if (e.type === removeEventByIdSuccess.type) {
                onClose(`${id}`).then(() => {
                    const mainTabbRoutePath = createMainTabbRoutePath({pathName: TabId.EVENTS});

                    navigate(mainTabbRoutePath);
                    dispatch(cleanEventsInfo());
                    dispatch(getAllEvents());
                    dispatch(getEventCount());
                    dispatch(getUniqueAttributeTitleCount());
                    dispatch(getChangeRequestCount());
                });
            }

            if (e.payload.error && e.type === removeEventByIdFailure.type) {
                onCreateNote({
                    id: removeEventByIdFailure.type,
                    status: Status.ERROR,
                    message: e.payload.data.message,
                    buttonProps: {icon: Icons.CLOSE},
                    autoHideTimeout: 10000,
                });
            }
        });
    };

    return (
        <Group justify="space-between" style={{maxWidth: '90%'}}>
            <Group direction="v" gap="s" style={{minWidth: '70%'}}>
                <Group gap="xs">
                    <Item shrink={0}>Delete event code</Item>
                    <EllipsisTextHint bold={true}>{code}</EllipsisTextHint>
                </Group>
                <Group justify="start">
                    <Item>with source <strong>{source}</strong>?</Item>
                </Group>
            </Group>
            <FlatButton onClick={onClick}>Delete</FlatButton>
        </Group>
    );
};
